export default "__VITE_ASSET__SdQpiH5H__"